import Typography from "@material-ui/core/Typography";
import React, {useEffect} from "react";
import ErrorOutline from "@material-ui/icons/ErrorOutline"
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom"
import FuseAnimate from "../fuse-animate/fuse-animate";
import {useMediaQuery} from "@material-ui/core";
import red from "@material-ui/core/colors/red";


const ErrorScreen = (props) => {
    let history = useHistory();
    const scale = useMediaQuery('(max-width: 320px)') ? 0.85 : 1.0;
    //console.log('scale=', scale)

    // Scroll to top on mount
    useEffect( () => {
        document.getElementById('psb').scrollTo(0,0);
    }, [])  // <- empty deps means it runs only on load


    const state = props.error.status === 503 ? {
        title       : "Ooh, bad timing.",
        message     : "Sorry, we're down for maintenance right now.  Please try again in a few minutes.",
        buttonText  : "Try Again",
        buttonAction: "reload",
    } : props.error.status >= 500 ? {
        title       : "Oops, that's not good.",
        message     : "Look's like we have an internal issue.  Try again in a few minutes.",
        buttonText  : "Go Back",
        buttonAction: "back",
    } : props.error.status === 404 ? {
        title       : "I'm sure it was here...",
        message     : "Sorry, the page you're looking for isn't here any more.  Head to the Home page and find your way from there.",
        buttonText  : 'Go to Home',
        buttonAction: 'home',
    } : {
        title       : "Something's gone wrong...",
        message     : "Sorry, the server didn't like what we sent. Try reloading the page.",
        buttonText  : 'Reload the Page',
        buttonAction: 'reload',
    }

    const handleClick = () => {
        if (state.buttonAction === 'reload') {
            // Reload the page from the server, not the cache
            window.location.reload(true);
        }
        if (state.buttonAction === 'back') {
            history.goBack();
        }
        if (state.buttonAction === 'home') {
            history.push("/");
        }
    }

    return (
        <Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
            <Box display="flex" flexDirection="column" alignItems="center">
                <FuseAnimate animation="transition.expandIn" delay={100}>
                    <Box display="flex" direction="row" alignItems="center" height={100}>
                        <ErrorOutline style={{fontSize: 110*(scale), color: red[800]}} />
                        <Box fontWeight={500} fontSize={110*scale} letterSpacing={0} pl={2*scale} lineHeight="110px" height={110*scale}>{props.error.status}</Box>
                    </Box>
                </FuseAnimate>
                <FuseAnimate animation="transition.expandIn" delay={200}>
                        <Box pt={3} pb={3}>
                            <Typography variant="h5" color="textSecondary" style={{fontSize: 24*scale}}>{state.title}</Typography>

                        </Box>
                </FuseAnimate>
                <FuseAnimate animation="transition.expandIn" delay={200}>
                        <Box pb={3} width={300*scale}>
                            <Typography color="textSecondary">{state.message}</Typography>
                        </Box>
                </FuseAnimate>
                {state.buttonAction !== '' &&
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                        <Button variant="contained" color="secondary" onClick={handleClick}>{state.buttonText}</Button>
                    </FuseAnimate>
                }
            </Box>
        </Box>
    )
}

export default ErrorScreen;